import { useEffect, useRef } from 'react';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import EditComponent from './MembershipRechargePlansApplicablesMerchantsEdit';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';

const WebComponent = (props: any) => {
    const title = '会员充值方案适合商户';
    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;

    useEffect(() => {

    }, []);

    //表头
    const columnsHead = [
        {
            title: '商户',
            dataIndex: 'merchant',
            render: (text: any) => text?.merchantName
        },
        {
            title: '充值方案',
            dataIndex: 'membershipRechargePlans',
            render: (text: any) => text?.planName
        },
        {
            title: '默认支付',
            dataIndex: 'isDefaultPayment',
            render: (val: any) => val === true ? '是' : '否'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: title,
        apiId: 'membershipRechargePlansApplicablesMerchants',
        columns,
        EditComponent,
        serviceId: 'business',
        sendPageData: data,
        showStates: true
    };

    return (
        <>
            <AntDraggableModal
                title={title}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={800} >
                <WebUniversal props={extendProps} ref={ref} />
            </AntDraggableModal>
        </>
    )
}

export default WebComponent;
